import { defineStore } from 'pinia';
import { storeConfig } from '@/shared/storeConfig';
import type { LoginHistory } from '@/types/UserHistory';

export const useUserHistoryStore = defineStore(
  'userHistory',
  () => {
    const loadingUserHistory = ref<boolean>(false);
    const loginHistory = ref<LoginHistory>({} as LoginHistory);

    function setLoginHistory(history: LoginHistory) {
      loginHistory.value = history;
    }

    function $reset() {
      loadingUserHistory.value = false;
      loginHistory.value = {} as LoginHistory;
    }

    return {
      loadingUserHistory,
      loginHistory,
      setLoginHistory,
      $reset,
    };
  },

  storeConfig,
);
